module.exports = __webpack_public_path__ + "static/2017_WSC_Group_2017_Business_Checklist-85035d1fde4b25b699105b754546dc61.pdf";